import { app } from '@lib';

export default {
  // 发送验证码
  sendLoginSms(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/ua/authAc/account/sendLoginSms ',
      params,
    });
  },
  // 修改密码
  resetPassword(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/ua/login/resetPassword',
      params,
    });
  },
  // 切换机构
  changeCompany(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/websession/changeCompany',
      params,
    });
  },
};
